const showImages = {
    "Nocny Promil": "nocny_promil_web.jpg",
    "Audycja Inaczej niż w radiu": "inaczej_niz_w_radiu_web.jpg",
    "Inaczej niż w streamingu": "inaczej_niz_w_streamingu_web.jpg",
    "Kawa i Promile": "kawa_i_promile.png",
    "The 70's Show": "70sshow_web.jpg",
    "Audycja Latynoska": "latina_web.jpeg",
    "Audycja Latynoska ": "latina_web.jpeg",
    "Muzyka Sprzed Rock'n'Rolla": "muzyka_sprzed_rocknrolla_web.jpg",
    "00's mix": "00smix_web.jpg",
    "80's mix": "80smix_web.jpg",
    "90's mix": "90smix_web.jpg",
    "Classic Rock": "classicrock_web.jpg",
    "0,7 po 20": "07_web.png",
    "Hip Hop Promil": "hiphop_web.jpg",
    "Jazzujemy z Promilem": "jazz_web.jpg",
    "Under the Covers": "under_the_covers_web.jpeg",
    "The Headbang Express": "the_headbang_express_web.jpeg",
    "Rap Gie": "Rap_Gie_web.JPG",
    "Winamp Playlist": "winamp.jpg",
    "Promillenials": "promillenials.jpg",
    "Promil OST": "promil_ost_web.jpg",
    "Girl Power Hour": "girl_power_web.jpg",
    "Hangover Playlist": "hangover_web.jpg",
    "W domach z betonu – dźwięki PRL": "prl_web.jpg",
    "Półtora Godziny Półtoraka": "poltorak_web.jpg",
    "Promil Nowej Fali": "nowa_fala_web.jpg",
    "Przez Promila Do Serca": "przez_promila_do_serca_web.jpg",
    "Wieczorne Warki": "wieczorne_warki_web.jpg",
    "Lato z Promilem": "lato_z_promilem_web.jpg",
    "Jugoton": "jugoton_web.jpg",
    "Jesień z Dupy Średniowiecza": "jesien_web.jpg",
    "Fika z Promilem": "fika_web.jpg"
};

export default showImages;
